var React = require('react');

function Triangle (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"transform":"translate(-805 -53)","fill":"currentColor"},React.createElement("g",{"transform":"translate(805 53)"},React.createElement("polygon",{"transform":"translate(5.5 2.5) rotate(180) translate(-5.5 -2.5)","points":"5.5 0 11 5 0 5"})))));
}

Triangle.defaultProps = {"version":"1.1","viewBox":"0 0 11 5"};

module.exports = Triangle;

Triangle.default = Triangle;
